import { MODAL_REDUCER_NAME, MODAL_TYPES } from './Constants';

const useModal = ({ [MODAL_REDUCER_NAME]: { modals } }) => modals[MODAL_TYPES.PAGE_MOVE];

// const useHideModal = ({ [MODAL_REDUCER_NAME]: { hideModal } }) => hideModal;

// const useSub = ({
//   [MODAL_REDUCER_NAME]: {
//     user: { sub },
//   },
// }) => sub;

// const useUser = ({ [MODAL_REDUCER_NAME]: { user } }) => user;

export { useModal };
